module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.current) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "news-detail-panel"
    }
  }, [(_vm.showMessage) ? _c('messageModal', {
    attrs: {
      "message": "votre news a été mis à jour !"
    },
    on: {
      "closeMessage": _vm.goToDetail
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "detailed-news-panel"
  }, [_c('div', {
    staticClass: "detailed-news-panel-title"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "medium-9 columns"
  }, [_c('p', {
    attrs: {
      "id": "tit",
      "contenteditable": "true"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.current.title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "medium-3 columns"
  }, [_c('div', {
    staticClass: "detailed-news-actions"
  }, [_c('button', {
    staticClass: "big",
    on: {
      "click": _vm.updateContent
    }
  }, [_vm._v("Publier")])])])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "panel-content",
    attrs: {
      "id": "post_content"
    }
  }, [_c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-5 columns"
  }, [_c('imageEditor', {
    ref: "imgEditor",
    attrs: {
      "imageSrc": _vm.current.featured_image
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "large-7 columns",
    staticStyle: {
      "text-align": "justify"
    },
    attrs: {
      "id": "par1",
      "contenteditable": "true"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.par1)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row columns",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('div', {
    staticClass: "large-12 columns",
    attrs: {
      "id": "par2",
      "contenteditable": "true"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.par2)
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "big",
    on: {
      "click": _vm.updateContent
    }
  }, [_vm._v("Publier")])], 1) : _c('div', {
    staticClass: "row"
  }, [_c('spinner')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79684491"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/news/news-edit.vue
// module id = 774
// module chunks = 0